export default __webpack_public_path__ + "static/media/1.20f49e2f.jpg";